import { defineComponent, toRefs } from "@vue/composition-api";
import { useLanguageSelector } from "@Client/@Composables/useLanguageSelector";
import { scrollBottom } from "@Shared/@Utils/utils";
export default defineComponent({
  name: "ApplicationQuickActions",
  props: {
    withConfirmation: {
      type: Boolean,
      default: true
    }
  },
  setup(props) {
    const {
      withConfirmation
    } = toRefs(props);
    const {
      localeLanguageOptions,
      currentLocale,
      handleLanguageSelect
    } = useLanguageSelector({
      withConfirmation: withConfirmation
    });
    const triggerScrollBottom = () => {
      scrollBottom();
    };
    return {
      localeLanguageOptions,
      currentLocale,
      handleLanguageSelect,
      triggerScrollBottom
    };
  }
});